<template>
  <div style="background-color: #94070a;" class="ftdiv bg-red twhite" :class="{sftdiv:isEnroll==1}">
    <div class="htmldiv">
      <div class="ldiv dinline-block vcenter">
        <div class="tdiv pt20 pb20">
          <a href="index.htm" class="vtop">
            <img src="../../assets/images/index_01_01.png">
          </a>
          <div class="txt dinline-block vtop lh16 ml45 mt5">
            <div class="sden dinline-block phone">
              <span class="mr30 dinline-block">{{info.telephones}}</span>
            </div>
            <div class="sden dinline-block email mr30">{{info.header_master_email}}</div>
            <div class="sden address">{{info.school_address}}</div>
          </div>
        </div>
        <div class="andiv pt15 pb15 mat">
          <span class="mr15 ml10 fs14">版权所有：常山技工学校</span>
          <span class="mr15 fs14">ICP备案号：
            <a style="color: #fff;" href="https://beian.miit.gov.cn/" target="_blank">
            浙ICP备2022008759号-1
            </a>
			    </span>
          <span class="mr10">
					<a style="color: #fff;" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33082202000088" target="_blank">公安部备案号：33082202000088</a>
				</span>
          <span class="fs14">建议使用IE10及以上版本浏览器浏览，推荐分辨率：1920*1080</span>
        </div>
      </div>
      <!--      wx-->
      <div class=" fr vcenter">
        <div class="dinline-block tcenter mt25 mr10">
          <img src="../../assets/images/index_02_01.png" alt="" width="90" height="90">
          <div class="mt5">官方公众号</div>
        </div>
        <div class="dinline-block tcenter">
          <a href="https://www.720yun.com/vr/6d8jO04fOk8" target="_blank">
            <img src="../../assets/images/index_02_02.png" alt="" width="90" height="90">
          </a>
          <div class="mt5">VR二维码</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Bottom",
  props:[
    'isEnroll'
  ],
  data(){
    return {
      info:{},
    }
  },
  mounted() {
    this.getData();
  },
  methods:{
    getData(){
      this.$request.get('bottom-config',[],response => {
        if(response.data.code == 200){
          this.info = response.data.data
        }
        console.log(this.info)
      },error => {
        console.log(error)
      })
    },
  }
}
</script>

<style scoped>
.andiv{word-wrap: break-word;word-break: break-all;}
.ldiv{width: 1080px;}
/*.ftdiv.sftdiv .htmldiv{width: 1200px;}*/
.ftdiv.sftdiv .txt{width: 640px;}
.andiv{word-wrap: break-word;word-break: break-all;}

</style>



// WEBPACK FOOTER //
// src/components/enroll/Bottom.vue